"use client"

import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import { useRef, useState } from "react"
import { Container, Desktop, Mobile } from "ui"
import VideoPauseIcon from "ui/icons/video/VideoPauseIcon"
import VideoPlayIcon from "ui/icons/video/VideoPlayIcon"
import ImageWithAlt from "ui/ImageWithAlt"
import { extractImage, getUmbracoMediaUrl } from "utils"

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
  }
  > div {
    width: 100%;
    max-width: 800px;
  }
`

const StyledImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
  border-radius: 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    max-width: 800px;
    /* height: 100%; */
    min-height: 667px;
  }
  img {
    object-fit: cover;
  }
`

const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
`

const StyledButtonDiv = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`

type Props = {
  data: any
}

function ArticlePic({ data }: Props) {
  const articlePicDescktop = extractImage(data, "articlePicDescktop")
  const articlePicMobile = extractImage(data, "articlePicMobile")
  const videoExtensions = /\.(mp4|mov|avi|wmv|flv|mkv)$/i
  const videoRef = useRef<HTMLVideoElement>(null)
  const videoRefMobile = useRef<HTMLVideoElement>(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play()
      setIsPlaying(true)
    }
    if (videoRefMobile.current) {
      videoRefMobile.current.play()
      setIsPlaying(true)
    }
  }

  const handlePause = () => {
    if (videoRef.current) {
      videoRef.current.pause()
      setIsPlaying(false)
    }
    if (videoRefMobile.current) {
      videoRefMobile.current.pause()
      setIsPlaying(false)
    }
  }

  return (
    <Container>
      <StyledDiv>
        <Desktop>
          {videoExtensions.test(articlePicDescktop?.url) ? (
            <StyledImageWrapper>
              <StyledVideo loop muted={true} ref={videoRef} playsInline>
                <source src={getUmbracoMediaUrl(articlePicDescktop?.url)} type="video/mp4" />
              </StyledVideo>
              <StyledButtonDiv>
                <IconButton onClick={isPlaying ? handlePause : handlePlay}>
                  {isPlaying ? <VideoPauseIcon /> : <VideoPlayIcon />}
                </IconButton>
              </StyledButtonDiv>
            </StyledImageWrapper>
          ) : (
            <StyledImageWrapper>
              <ImageWithAlt image={articlePicDescktop} layout="fill" />
            </StyledImageWrapper>
          )}
        </Desktop>
        <Mobile>
          {videoExtensions.test(articlePicMobile?.url) ? (
            <StyledImageWrapper>
              <StyledVideo loop muted={true} ref={videoRefMobile} playsInline>
                <source src={getUmbracoMediaUrl(articlePicMobile?.url)} type="video/mp4" />
              </StyledVideo>
              <StyledButtonDiv>
                <IconButton onClick={isPlaying ? handlePause : handlePlay}>
                  {isPlaying ? <VideoPauseIcon /> : <VideoPlayIcon />}
                </IconButton>
              </StyledButtonDiv>
            </StyledImageWrapper>
          ) : (
            <StyledImageWrapper>
              <ImageWithAlt image={articlePicMobile} layout="fill" />
            </StyledImageWrapper>
          )}
        </Mobile>
      </StyledDiv>
    </Container>
  )
}

export default ArticlePic
